import * as React from 'react';
import { createPortal } from 'react-dom';
import injectSheet from 'react-jss';
import * as styles from './index.jss';
import { TimePicker } from 'antd';
import { TimePickerProps } from 'antd/lib/time-picker';
import ClickAwayListener from '../click-away-listener';


export interface IStupidTimePickerProps extends TimePickerProps {
  classes: { [key in keyof typeof styles]: string };
  onClickAway: () => void;
}



class StupidTimePicker extends React.Component<IStupidTimePickerProps>{
  private node: HTMLDivElement | null = null;

  public componentWillMount() {
    this.node = document.createElement('div');
    document.body.appendChild(this.node);
  }
  private getPickerNode = () => {
    const { classes } = this.props;
    return document.querySelector('.' + classes.datepickerDropdown);
  }

  public componentWillUnmount() {
    document.body.removeChild(this.node!);
    this.node = null;
  }

  public render() {
    const { classes, onClickAway, ...rest } = this.props;

    return createPortal(
      <ClickAwayListener
        onClickAway={onClickAway}
        getChildNode={this.getPickerNode}
      >
        <TimePicker
          {...rest}
          allowEmpty={false}
          className={classes.datepicker}
          popupClassName={classes.datepickerDropdown}
        />
      </ClickAwayListener>,
      this.node!
    );
  }
}

export default injectSheet(styles)(StupidTimePicker);
